import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import isLocalhost from 'utils/isLocalhost';
import type { AppName } from 'types';

export const dsnMap: { [env: string]: string } = {
  admin: 'https://5370e90817af4a5baf2f134e5db59d01@o446952.ingest.sentry.io/5426270',
  customer: 'https://f1b5ea98cb4e44f785a91f38f857747c@o446952.ingest.sentry.io/5426272',
  intake: 'https://56085c8457b24d1e98fdde5461975804@o446952.ingest.sentry.io/5899441',
  onboarding: 'https://6b786bd605224c7aaadb15a1de713887@o446952.ingest.sentry.io/6021901',
  portal: 'https://037c4a5e22e04581b9b0e51ebd599af3@o446952.ingest.sentry.io/5662271',
  specialist: 'https://df45dbfe7df64a0c9a385e77e37fb5b7@o446952.ingest.sentry.io/5426274',
  validation: 'https://61c492cc31814126853bd2357126908e@o446952.ingest.sentry.io/6021899',
};

function getDsn(appName: AppName) {
  const dsn = dsnMap[appName];

  if (!dsn) {
    throw new Error(`initSentry Error: Unsupported app: ${appName}.`);
  }
  return dsn;
}

export function getEnvironment() {
  const { hostname } = window.location;
  if (
    isLocalhost()
    || hostname.includes('localhost')
    || hostname.includes('.local')
    || hostname.includes('192.168')
  ) {
    return 'local';
  }
  if (hostname.includes('-staging.metropolis.io')) {
    return 'staging';
  }
  if (hostname.includes('-beta.metropolis.io')) {
    return 'production-beta';
  }
  return 'production';
}

export default function initSentry({
  appName,

  /** Custom options to pass to init() */
  options,
}: {
  appName: AppName;
  options?: Sentry.BrowserOptions
}) {
  try {
    const dsn = getDsn(appName);
    const environment = getEnvironment();

    if (environment !== 'production') {
      return;
    }

    Sentry.init({
      dsn,
      environment,
      integrations: [new Integrations.BrowserTracing()],
      tracesSampleRate: 1,
      allowUrls: ['metropolis.io'], // This will also match any subdomain of metropolis.io
      ignoreErrors: [
        'TypeError: Failed to fetch',
        'TypeError: The request timed out.',
        'TypeError: The network connection was lost.',
        'TypeError: cancelled',
        'TypeError: The Internet connection appears to be offline.',
      ],
      ...options,
    });
  } catch (e) {
    if (e instanceof Error) {
      // eslint-disable-next-line
      console.error(e);
    }
  }
}
